import script from "./Completion2Menu.vue?vue&type=script&lang=ts&setup=true"
export * from "./Completion2Menu.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__